export const buttonOptions = [
  {
    label: `Go to cohort`,
    value: `go-to-cohort`,
  },
  {
    label: `Create a cohort`,
    values: [
      {label: `This step`, value: `this-step`},
      {label: `Up to this step`, value: `up-to-this-step`},
    ],
  },
  {
    label: `Hide event`,
    values: [
      {label: `This event`, value: `this-event`},
      {label: `The following event`, value: `following-event`},
    ],
  },
  {
    label: `Breakdown`,
    value: `breakdown`,
  },
];

export const cohortDetails = [
  {
    name: `Cohort for Viewed Report`,
    description: `This is a cohort for Viewed Report`,
    type: `this-step`,
  },
  {
    name: `Cumulative Cohort for Viewed Report`,
    description: `This is a cohort all steps leading up to Viewed Report`,
    type: `up-to-this-step`,
  },
];
